import React, { useState, useContext, useRef } from "react";
import { AHEAD_SEARCH } from "../redux/links";
import { I18nContext } from "../i18n/index";
import { navigate } from "gatsby";

export default function SearchHelper() {
  const { translate } = useContext(I18nContext);
  const [keywords, setKeywords] = useState([]);
  const [finalRecording, setFinalRecording] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [searchInputFocused, setSearchInputFocused] = useState(false);
  const [searchInOption, setSearchInOption] = useState("all");

  const inputRef = useRef();

  const handleSubmit = (evt) => {
    evt.preventDefault();
    if (evt.target.tagName == "P") {
      navigate(`/search/${evt.target.textContent}`);
    } else {
      navigate(`/search/${searchInput}`);
    }
  };

  const handleKeyClicked = (key) => {
    navigate(`/search/${key}`);
  };

  const helpSearch = (e) => {
    e.persist();

    const { value } = e.target;
    if (finalRecording != "") {
      setFinalRecording("");
    }
    setSearchInput(value);
    if (searchInput.length > 1) {
      let link = AHEAD_SEARCH(searchInput);
      fetch(link).then((res) => {
        res.text().then((text) => {
          text = text.split("\n");
          setKeywords(text);
        });
      });
    }
    if (value == "") {
      setKeywords([]);
    }
  };

  const setStyles = () => {
    if (inputRef.current) {
      let inputPosition = inputRef.current.getBoundingClientRect();

      return {
        top: `${inputPosition.top - 18}px`,
        left: `${inputPosition.left}px`,
        width: `${inputPosition.width}px`,
      };
    }
  };

  const handleSetSearchInputFocusState = (state) => {
    if (state === false) {
      setTimeout(() => setSearchInputFocused(state), 100);
    } else {
      setSearchInputFocused(state);
    }
  };

  const handleSearchChange = (event) => {
    setSearchInOption(event.target.value);
  };

  return (
    <div className="searchInfo">
      <form
        id="searchForm"
        onSubmit={handleSubmit}
        className={searchInputFocused ? "active" : ""}
      >
        <label htmlFor="search-input-help" className="sr-only">
          {translate("js.header.searchfor")}
        </label>
        <input
          ref={inputRef}
          onFocus={() => handleSetSearchInputFocusState(true)}
          onBlur={() => handleSetSearchInputFocusState(false)}
          type="text"
          name="keyword"
          id="search-input-help"
          autoComplete="off"
          onChange={(e) => helpSearch(e)}
          // placeholder={translate("js.header.searchfor")}
          placeholder={`Search among ${searchInOption}`}
          value={searchInput}
        />
        <span className="material-icons">search</span>

        <label className="sr-only" htmlFor="search-in">
          Search In
        </label>
        <select
          id="search-in"
          onChange={handleSearchChange}
          className="search-in"
        >
          <option value="all">All</option>
          <option value="products">Products</option>
          <option value="categroies">Categroies</option>
          <option value="producers">Producers</option>
        </select>

        {keywords && keywords.length > 0 && keywords[0] ? (
          <div
            style={setStyles()}
            className={
              searchInputFocused
                ? "search-typeahead-container active"
                : "search-typeahead-container"
            }
          >
            <ul>
              {keywords.map((key) => (
                <li onClick={() => handleKeyClicked(key)}>{key}</li>
              ))}
            </ul>
          </div>
        ) : null}
      </form>
    </div>
  );
}
